import React from 'react';
import useDebugInformation from "@hooks/useDebugInformation";
import CustomerMenu from './CustomerMenu';
import MainMenu from './MainMenu';
import MiddleBar from './MiddleBar';
import { Box } from '@mui/material';
import FailDialog from './MainMenu/FailDialog';
import FailFeedbackDialog from './MainMenu/FailFeedbackDialog';

const menuId = 'primary-search-middlebar-menu';

type Props = {}

const FormBar: React.FC<Props> = () => {
    const [anchorMainEl, setAnchorMainEl] = React.useState<null | HTMLElement>(null);
    const [anchorCustomerMenuEl, setAnchorCustomerMenuEl] = React.useState<null | HTMLElement>(null);

    useDebugInformation("FormBar", { anchorMainEl, anchorCustomerMenuEl });
    return (
        <Box sx={{ flexGrow: 1 }}>
            <FailDialog />
            <FailFeedbackDialog />
            <MiddleBar menuId={menuId} setAnchorCustomerMenuEl={setAnchorCustomerMenuEl} setAnchorMainEl={setAnchorMainEl} />
            <MainMenu anchorEl={anchorMainEl} menuId={menuId} />
            <CustomerMenu anchorEl={anchorCustomerMenuEl} />
        </Box >
    );
}

export default React.memo(FormBar)